import React, { useState } from 'react'
import vg from '../assets/vg.png'
import toast from 'react-hot-toast';
import { motion } from 'framer-motion';
import {addDoc,collection} from "firebase/firestore"
import { db } from '../firebase';


const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);

  const submitHandler = async(e)=>{
    e.preventDefault();//yane page reload nhi hot
    // console.log(name,email,message)
    setDisableBtn(true);
    try {
      await addDoc(collection(db,"contacts"),{
        name,
        email,
        message,
      });
      setName("");
      setEmail("");
      setMessage("");
      toast.success("Message Sent");
      setDisableBtn(false);
    } catch (error) {
      toast.error("Error");
      console.log(error);
    }
  }

  const animations={
    form:{
      initial:{
        opacity:0,
        x:"-100%",
      },
      whileInView:{
        opacity:1,
        x:0
      }
    },
    button:{
      initial:{
        opacity:0,
        y:"-100%",
      },
      whileInView:{
        opacity:1,
        y:0
      },
      transition:{
        duration:0.5,
        delay:0.5
      }
    },
    
    
  }
  return (
    <div id='contact'>
      <section>

        <motion.form onSubmit={submitHandler} {...animations.form}
        >
            <h2>Contact Me</h2>

            <input type="text" placeholder='Your Name' 
            value={name}
            onChange={(e)=>setName(e.target.value)}
            required />
            
            <input type="email" placeholder='Your Email'
            value={email}
            onChange={
              (e)=>setEmail(e.target.value)
            }
             required />

            <input placeholder='Your Message' required
            value={message}
            onChange={(e)=>setMessage(e.target.value)}
            ></input>

            <motion.button className={
              disableBtn ? "disableBtn" : ""
            } disabled={disableBtn} type='submit' {...animations.button}>Send Message</motion.button>
        </motion.form>
      </section>
      <aside>
        <img src={vg} alt="Graphics" />
      </aside>
    </div>
  )
}

export default Contact